import React from 'react';

import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import Tabs from '../../components/Tabs';
import useTab from '../../utils/react/hooks/useTab';

import { ContentContainer, PageContainer } from './index.styles';
import ProfileTab from './ProfileTab';
import SettingsTab from './SettingsTab';

const TAB_OPTIONS = [
  {
    key: 'profile',
    label: 'Profile',
    icon: <PersonOutlinedIcon />,
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: <SettingsOutlinedIcon />,
  },
];

const ProfilePage = () => {
  const [tab, setTab] = useTab({ default: TAB_OPTIONS[0].key });

  return (
    <PageContainer>
      <Tabs options={TAB_OPTIONS} selectedKey={tab} onChange={(key) => setTab(key)} />
      <ContentContainer>
        {
          tab === 'profile' && <ProfileTab />
        }
        {
          tab === 'settings' && <SettingsTab />
        }
      </ContentContainer>
    </PageContainer>
  );
};
export default ProfilePage;
